/*Todo: This OwnerType is ContactOwner in our Legacy System and New OwnerType is actual OwnerType*/
const OwnerType = {
    DEPARTMENT: 1,
    CLIENT: 2,
    DISTRIBUTOR: 3,
    REPAIRS: 4
};

export { OwnerType };

const NewOwnerType = {
    CONTRACT : 1,
    REPAIR : 2,
    SCOPE : 3,
    SCOPETYPE : 4,
    REPAIRITEM : 5,
    INVENTORYITEM : 6,
    INVENTORYSIZE : 7,
    PENDINGCONTRACT : 8
}

export { NewOwnerType };